/**
 * Javascript replica of our pagination markup.
 * @param  {Number} maxNumPages The total number of pages.
 * @param  {Number} currentPage The current page.
 * @param  {Number} maxPages    The max amount of pages to show at one time.
 * @param  {String} classes     The classes for the pagination wrapper.
 */
export const emPagination = async (maxNumPages, currentPage) => {
	const { restUrl } = window.emJsData;
	const response = await fetch(`${restUrl}pagination?total_pages=${maxNumPages}&current=${currentPage}&use_buttons=true`);
	const html = await response.text();
	return html ? JSON.parse(html) : '';
};

/**
 * Load More Button.
 * @param  {Number} maxNumPages The total number of pages.
 * @param  {Number} currentPage The current page.
 * @param  {String} btnText     The load more button text.
 * @param  {String} classes     The button classes.
 * @return {string}             The button markup.
 */
export const emLoadMore = (maxNumPages, currentPage, btnText = 'Load More', classes = 'btn btn--style-primary has-primary-background-color load-more') => {
	const isEnabled = currentPage < maxNumPages;
	const page = isEnabled ? currentPage + 1 : 0;
	const disabled = !isEnabled ? 'disabled' : '';
	return `<button class="${classes}" data-page="${page}" ${disabled}><span>${btnText}</span></button>`;
};
